<template>
    <transition name="fade">
        <div class="order-exchange-return">
            <!-- 全屏Loading -->
            <div class="fullscreen-loading" v-if="confirm_loading">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <div class="loading-desc">处理中,请稍候...</div>
                </div>
            </div>
            <div class="exchange-return-body">
                <Icon type="md-close" @click="close" size="18" class="close-ico" />
                <div class="main-title">确认同意换货</div>
                <div class="after-sale-info">
                    <div class="title">售后详情</div>
                    <div class="detail">
                        <div class="detail-item">
                            <div class="label">订单编号：</div>
                            <div class="value">{{order.ord.order_no}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">售后类型：</div>
                            <div class="value main">{{order.type_name}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">退货原因：</div>
                            <div class="value">{{order.user_reason}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">换新规格：</div>
                            <div class="value">{{order.new_product.name}}({{ order.new_product.spec_info }})</div>
                        </div>
                        <div class="img-list" v-viewer>
                            <template v-for="(item,index) in order.user_proof">
                                <img v-if="util.test_image(item)" :src="item|default_img" alt="" class="img-item" :key="`img-${index}`" />
                                <div v-else-if="util.is_video(item)" class="video-wrapper" :key="`video-${index}`" @click.stop="previewVideo(item)">
                                    <img :src="`${item}?x-oss-process=video/snapshot,t_1000,m_fast`" class="img-item" />
                                    <img src="@/assets/images/icon-mall-play.png" class="video-play-icon" />
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="title required">换新规格确认</div>
                    <div class="exchange-spec-box">
                        <img :src="order.goods.product_image|default_img" alt="" class="products-cover" />
                        <div class="products-info">
                            <div class="products-name">{{ order.new_product.name }}</div>
                            <div class="products-spec"><span>{{order.new_product.spec_info}}</span><span>X {{order.goods.quantity}}</span></div>
                        </div>
                    </div>
                    <div class="title required">商品寄回地址</div>
                    <div class="refund-address">
                        <div class="address-left">
                            <div class="left-icon">收</div>
                            <div class="address-detail">
                                <div class="name-phone">
                                    <div class="name">{{shopInfo.return_name}}</div>
                                    <div class="phone">{{shopInfo.return_mobile}}</div>
                                </div>
                                <div class="address">
                                    {{shopInfo.return_address}}
                                </div>
                            </div>
                        </div>
                        <div class="address-right">
                            <div class="btn" @click="onAddressCopy">复制</div>
                            <div v-if="false" class="btn">重选</div>
                        </div>
                    </div>
                    <div class="title">换货备注(可选)</div>
                    <textarea v-model="form.shop_memo" placeholder="填写给买家的备注信息,如:请妥善包装商品,保留吊牌,退回商品需不影响二次销售哦~"></textarea>
                    <div class="tips">审核确认通过后,买家将收到退货地址和审核通过通知</div>
                </div>
                <div class="btn-box">
                    <div class="btn cancel" :class="{ disabled: confirm_loading }" @click="!confirm_loading && close()">取消</div>
                    <div class="btn confirm" :class="{ loading: confirm_loading, disabled: confirm_loading }" @click="onConfirmExchange">
                        <span v-if="confirm_loading" class="loading-text">处理中...</span>
                        <span v-else>确认同意换货</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { afterSaleApplyAgree } from '@/api/index';
import util from '@/utils/util';
import { mapState } from 'vuex';
export default{
    name:"OrderExchangeConfirm",
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
           util: util,
           form:{
                uuid:'',
                shop_memo:'',
           },
           confirm_loading:false
        }
    },
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo,
            userInfo:state=>state.userInfo
        })
    },
    mounted(){
        this.form.uuid = this.order.uuid;
    },
    methods:{
        async previewVideo(url){
            const mask = document.createElement('div');
            mask.className = 'video-preview-mask';
            mask.onclick = (e) => {
                if(e.target === mask) this.closeVideoPreview();
            };
            mask.innerHTML = `
                <div class="video-preview-container" onclick="event.stopPropagation()">
                    <div class="video-preview-close" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.closeVideoPreview()">×</div>
                    <div class="video-wrapper-fix">
                        <div class="video-preview-loading">
                            <div class="video-loading-spinner"></div>
                            <span class="video-detect-text">视频文件检测中...</span>
                        </div>
                    </div>
                </div>
            `;
            mask.__vueComponent = this;
            document.body.appendChild(mask);

            const playable = await util.probeVideoPlayable(url);
            if (!mask.parentNode) return;

            const wrapper = mask.querySelector('.video-wrapper-fix');
            if(playable){
                wrapper.innerHTML = `
                    <video src="${url}" controls autoplay class="video-preview" disablePictureInPicture controlsList="nodownload"></video>
                `;
            } else {
                wrapper.innerHTML = `
                    <div class="video-unplayable-box" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.downloadVideo('${url}')">
                        <span class="hint-text">该视频只支持下载预览</span>
                        <span class="download-link">点击下载</span>
                    </div>
                `;
            }
        },
        downloadVideo(url){
            util.downloadVideo(url);
        },
        closeVideoPreview(){
            const mask = document.querySelector('.video-preview-mask');
            if(mask){
                mask.remove();
            }
        },
        onAddressCopy(){
            navigator.clipboard.writeText(this.shopInfo.return_name + this.shopInfo.return_mobile + this.shopInfo.return_address).then(() => {
                this.$layer.msg("复制成功");
            });
            console.log('复制地址');
        },
        async onConfirmExchange(){
            if(this.confirm_loading) return;
            this.confirm_loading = true;
            try{
                const {code,msg} = await afterSaleApplyAgree(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$bus.$emit('list-refresh');
                this.close();
            }catch(e){
                console.log('err-exchange-confirm',e);
                this.$layer.msg('操作失败,请重试');
            }finally{
                this.confirm_loading = false;
            }
        },
        close(){
            this.$emit("close")
        }
    }
}
</script>
<style lang="scss" scoped>
.order-exchange-return{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.5);
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:110;
    user-select: none;
    .fullscreen-loading{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:200;
        background:rgba(0,0,0,0.6);
        display:flex;
        align-items:center;
        justify-content:center;
        .loading-spinner{
            display:flex;
            flex-direction:column;
            align-items:center;
            row-gap:16px;
            .spinner{
                width:40px;
                height:40px;
                border:3px solid rgba(255,255,255,0.3);
                border-top-color:#fff;
                border-radius:50%;
                animation:spin 0.8s linear infinite;
            }
            .loading-desc{
                color:#fff;
                font-size:14px;
            }
        }
    }
    @keyframes spin{
        to{transform:rotate(360deg);}
    }
    .exchange-return-body{
        width:508px;
        height:auto;
        max-height:800px;
        // overflow-y:auto;
        position:relative;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        .close-ico{
            position:absolute;
            top:14px;
            right:14px;
            cursor:pointer;
        }
        .main-title{
            width:100%;
            text-align:center;
            margin-top:18px;
            padding-bottom:13px;
            font-size:18px;
            font-weight:bold;
            color:#0f1115;
            border-bottom:1px solid #e0e0e0;
        }
        .after-sale-info{
            width:100%;
            flex:1;
            padding:0 24px;
            overflow-y:auto;
            .title{
                color:#333;
                font-size:14px;
                margin-top:13px;
                &.required::after{
                    content:"*";
                    color:red;
                }
            }
            .detail{
                width:100%;
                background:#f6f7f9;
                padding:14px 14px 8px 14px;
                border-radius:6px;
                display:flex;
                flex-direction:column;
                row-gap:9px;
                margin-top:8px;
                .detail-item{
                    width:100%;
                    display:flex;
                    align-items:center;
                    .label{
                        color:#333;
                        font-size:14px;
                    }
                    .value{
                        color:#333;
                        font-size:14px;
                        &.main{
                            color:#ff5967;
                            font-weight:bold;
                        }
                    }
                    .edit-btn{
                        display:flex;
                        align-items:center;
                        padding:0 8px;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        column-gap:4px;
                        cursor:pointer;
                        margin-left:16px;
                        .btn-icon{
                            width:16px;
                            height:16px;
                        }
                        .btn-text{
                            color:#666;
                            font-size:12px;
                        }
                    }
                }
                .img-list{
                    display:flex;
                    flex-wrap:wrap;
                    gap:8px;
                    .img-item{
                        width:60px;
                        height:60px;
                    }
                    .video-wrapper{
                        position:relative;
                        cursor:pointer;
                        .img-item{
                            width:60px;
                            height:60px;
                            object-fit:cover;
                        }
                        .video-play-icon{
                            position:absolute;
                            top:50%;
                            left:50%;
                            transform:translate(-50%,-50%);
                            width:20px;
                            height:20px;
                            pointer-events:none;
                        }
                    }
                }
            }
            .exchange-spec-box{
                width:100%;
                border:1px solid #e3e3e3;
                border-radius:10px;
                padding:16px;
                display:flex;
                column-gap:16px;
                margin-top:8px;
                .products-cover{
                    width:96px;
                    height:96px;
                    border:1px solid #e3e3e3;
                    border-radius:8px;
                }
                .products-info{
                    flex:0 0 calc(100% - 96px - 32px);
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    justify-content:center;
                    .products-name{
                        width:100%;
                        display:-webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp:2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        color:#666;
                        font-size:14px;
                    }
                    .products-spec{
                        width:100%;
                        display:flex;
                        column-gap:25px;
                        color:#666;
                        font-size:14px;
                    }
                }
            }
            .refund-address{
                width:100%;
                background:#f6f7f9;
                border-radius:6px;
                display:flex;
                align-items:center;
                padding:12px 14px 12px 10px;
                column-gap:21px;
                .address-left{
                    flex:0 0 calc(100% - 45px);
                    flex-shrink:0;
                    display:flex;
                    align-items:center;
                    column-gap:12px;
                    .left-icon{
                        background:#0066ff;
                        color:#fff;
                        border-radius:4px;
                        font-size:12px;
                        padding:0 4px;
                    }
                    .address-detail{
                        display:flex;
                        flex-direction:column;
                        row-gap:2px;
                        .name-phone{
                            display:flex;
                            align-items:center;
                            column-gap:24px;
                            .name,.phone{
                                color:#333;
                                font-size:14px;
                            }
                        }
                        .address{
                            color:#666;
                            font-size:12px;
                            white-space:nowrap;
                            text-overflow:ellipsis;
                            overflow:hidden;
                        }
                    }
                }
                .address-right{
                    flex:1;
                    flex-shrink:0;
                    display:flex;
                    flex-direction:column;
                    row-gap:5px;
                    .btn{
                        color:#0066ff;
                        font-size:12px;
                        cursor:pointer;
                    }
                }
            }
            textarea{
                width:100%;
                height:100px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                outline:none;
                padding:12px 16px;
                resize:none;
                margin-top:10px;
            }
            .tips{
                color:#666;
                font-size:12px;
                margin-top:10px;
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            justify-content:center;
            align-items:center;
            column-gap:10px;
            padding-top:14px;
            margin-bottom:27px;
            border-top:1px solid #e3e3e3;
            .btn{
                font-size:14px;
                cursor:pointer;
                font-weight:bold;
                height:40px;
                line-height:40px;
                border-radius:4px;
                &.cancel{
                    color:#666;
                    border:1px solid #e3e3e3;
                    padding:0 36px;
                }
                &.confirm{
                    color:#fff;
                    background:#ff5967;
                    padding:0 34px;
                    &.loading{
                        opacity:0.7;
                        pointer-events:none;
                    }
                    &.disabled{
                        pointer-events:none;
                    }
                }
                &.disabled{
                    opacity:0.5;
                    pointer-events:none;
                }
            }
        }
    }
}
::v-deep .change-money-body{
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    .label{
        color:#333;
        font-size:14px;
        margin-bottom:10px;
        width:100%;
        text-align:left;
    }
    .value{
        width:100%;
        height:48px;
        border:1px solid #e3e3e3;
        border-radius:4px;
        outline:none;
        padding:0 16px;
    }
}

::v-deep .footer-box{
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top:20px;
    margin-bottom:40px;
    column-gap:10px;
    .btn{
        font-size:14px;
        cursor:pointer;
        font-weight:bold;
        height:40px;
        line-height:40px;
        border-radius:4px;
        &.cancel{
            color:#666;
            border:1px solid #e3e3e3;
            padding:0 36px;
        }
        &.confirm{
            color:#fff;
            background:#ff5967;
            padding:0 34px;
        }
    }
}

::v-deep .ivu-modal-header{
    border-bottom:none;
}
::v-deep .ivu-modal-footer{
    border-top:none;
}
::v-deep .ivu-modal{
    top:30% !important;
}
</style>
